import {h, render} from 'preact';

function References({items}) {
    return (
        <div className="oQuiz__Result__Reference mReferenceList">
            <h3 className="aHeadline aHeadline--Tertiary">Références</h3>
            <ul className="mReferenceList__List">
            {Array.isArray(items) &&
                items.map(({item}) => (
                    <li className="mReferenceList__List__Item" dangerouslySetInnerHTML={{__html: item}}></li>
                ))
            }
            </ul>
        </div>
    )
}

export default References
